<template>
	<div class="box-box2-s1">
		<!-- 能耗图表 -->
		<h3>{{mychartTitle}}</h3>
		<div :id="mychartID" class="chart13"></div>
	</div>
</template>
<script>
import echarts from "echarts/lib/echarts"
import 'echarts/map/js/china.js';

export default {
  name: 'app',
  data(){
    return {
		mychartData: this.chartData || {name:[],value:[]},
		mychartTitle: this.chartTitle || "",
		mychartID: this.chartID || ""
    }
  },
  mounted(){
    this.$nextTick(function(){
    	this.drawChart();
	  })
	const timer = setInterval(() => {
		this.drawChart();			
	}, 5000);
	this.$once('hook:beforeDestroy', () => {
		clearInterval(timer);
	})
  },
  props:['chartData','chartTitle','chartID'],
  methods: {
	drawChart(){
		let chart = this.$echarts.init(document.getElementById(this.mychartID));		
		chart.setOption({						
			tooltip : {
				trigger: 'item',
				formatter: "{d}%"
			},
			legend:{
				show : false,
				orient : 'vertical',
				x : '2%',
				y : "2%",
				textStyle:{//图例文字的样式
					color:'#eee',
				},
				data:['空调','机柜',"其他"],
			},
			grid: {
				top:'0%'
			},
			series : [
			{
				name: '',
				type: 'pie',
				radius: "65%",
				data: this.mychartData || [],
				label: {
					normal: {
						show: true,
						formatter: "{c}",
					}
				},
				labelLine:{  
					normal:{  
						length:0  
					}  
				},
				itemStyle: {
					emphasis: {
						shadowBlur: 10,
						shadowOffsetX: 0,
						shadowColor: 'rgba(0, 0, 0, 0.5)'
					},
					normal:{
						//每个柱子的颜色即为colorList数组里的每一项，如果柱子数目多于colorList的长度，则柱子颜色循环使用该数组
						//var colorList = ['#31b0d5','#c9302c','#5cb85c','#aaa'];
						color: function (params){
						var colorList = ['#05faff','#3987fe','#f78024'];
						return colorList[params.dataIndex];
						}
					}
				}
			},
			{
				name: '能耗',
				type: 'pie',
				radius : '65%',
				data: this.mychartData || [],
				label: {
					normal: {
						show: true,
						formatter: "{b}",
						position : 'inner'
					}
				},
				itemStyle: {
					emphasis: {
						shadowBlur: 10,
						shadowOffsetX: 0,
						shadowColor: 'rgba(0, 0, 0, 0.5)'
					},
					normal:{
						//每个柱子的颜色即为colorList数组里的每一项，如果柱子数目多于colorList的长度，则柱子颜色循环使用该数组
						//var colorList = ['#31b0d5','#c9302c','#5cb85c','#aaa'];
						color: function (params){
						var colorList = ['#05faff','#3987fe','#f78024'];
						return colorList[params.dataIndex];
						}
					}
				}
			}
			]

	});
	},
	
  }
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/comss/chartThree.vue